@if (!isExtenders()) {
<mat-tab-group>
    <mat-tab label="Touche ligne 1-10">
        <app-blfs-form [blfsTypes]="blfsTypes()" [blfs]="getFilteredBlfs(0, 10)"></app-blfs-form>
    </mat-tab>
    <mat-tab label="Touche ligne 11-20">
        <app-blfs-form [blfsTypes]="blfsTypes()" [blfs]="getFilteredBlfs(10, 20)"></app-blfs-form>
    </mat-tab>
    <mat-tab label="Touche ligne 21-27">
        <app-blfs-form [blfsTypes]="blfsTypes()" [blfs]="getFilteredBlfs(20, 27)"></app-blfs-form>
    </mat-tab>
</mat-tab-group>
} @else {
<mat-tab-group>
    <mat-tab label="Touche ligne 1-20">
        <app-blfs-form [blfsTypes]="blfsTypes()" [blfs]="getFilteredBlfs(0, 20)"></app-blfs-form>
    </mat-tab>
    <mat-tab label="Touche ligne 21-40">
        <app-blfs-form [blfsTypes]="blfsTypes()" [blfs]="getFilteredBlfs(20, 40)"></app-blfs-form>
    </mat-tab>
    <mat-tab label="Touche ligne 41-60">
        <app-blfs-form [blfsTypes]="blfsTypes()" [blfs]="getFilteredBlfs(40, 60)"></app-blfs-form>
    </mat-tab>
</mat-tab-group>
}
